var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Animate } from "..";
var WrapWithAnimate = /** @class */ (function (_super) {
    __extends(WrapWithAnimate, _super);
    function WrapWithAnimate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WrapWithAnimate.prototype.render = function () {
        return this.props.children && this.props.shouldWrap ?
            React.createElement(Animate, __assign({}, this.props), this.props.children) : this.props.children;
    };
    return WrapWithAnimate;
}(React.Component));
export { WrapWithAnimate };
//# sourceMappingURL=WrapWithAnimate.js.map